import {ActionsUnion, createAction} from "@martin_hotell/rex-tils";
import {WorkPackage} from "../../models/responses/work-package.model";

export enum ActionNames {
    SET_WORK_PACKAGES = '[WBS] Set Work Packages',
    SET_WORK_STREAMS = '[WBS] Set Work Streams',
    SET_ACTIVE_WORK_PACKAGE = '[WBS] Set Active Work Package',
}


export const Actions = {
    setWorkPackages: (workPackages: WorkPackage[]) => createAction(ActionNames.SET_WORK_PACKAGES, {workPackages}),
    setWorkStreams: (workStreams: any[]) => createAction(ActionNames.SET_WORK_STREAMS, {workStreams}),
    setActiveWorkPackage: (workPackage: WorkPackage | null) => createAction(ActionNames.SET_ACTIVE_WORK_PACKAGE, {workPackage}),
};

export type Actions = ActionsUnion<typeof Actions>;